module.exports = __webpack_public_path__ + "static/img/3.1bca0b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/200204/3.jpg
// module id = UxuT
// module chunks = 1